<template>
  <div class="container">
    <h2>Consulta Título Timbrado</h2>
    <br/>
      <div class="bg-secondary text-white font-weight-bold px-3 py-2 rounded d-inline-block">
        Datos del alumno
      </div>
    <hr>
    <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                  label="Nombre:"
                  label-for="input-sm">
      <b-form-input id="nombre" size="sm"
                    v-bind:value="datos.nombreAlumno"
                    readonly>
      </b-form-input>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                  label="Institución educativa:"
                  label-for="input-sm">
      <b-form-input id="Institucion_Educativa" size="sm"
                    v-bind:value="datos.institucionEdu"
                    readonly>
      </b-form-input>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                  label="Carrera cursada:"
                  label-for="input-sm">
      <b-form-input id="Carrera_Cursada" size="sm"
                    v-bind:value="datos.carreraCursada"
                    readonly>
      </b-form-input>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                  label="Carrera cursada:"
                  label-for="input-sm">
      <b-form-input id="Carrera_Cursada" size="sm"
                    v-bind:value="datos.carreraCursada"
                    readonly>
      </b-form-input>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                  label="Entidad Federativa de Expedición:"
                  label-for="input-sm">
      <b-form-input id="Entidad_Federativa_Expedicion" size="sm"
                    v-bind:value="datos.entFedExpedicion"
                    readonly>
      </b-form-input>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                  label="Fecha de Expedición:"
                  label-for="input-sm">
      <b-form-input id="Fecha_Expedicion" size="sm"
                    v-bind:value="datos.fechaExpedicion"
                    readonly>
      </b-form-input>
    </b-form-group>

    <b-form-group class="font-weight-bold" label-cols="3" label-cols-lg="3" label-size="sm"
                  label="Cadena original:"
                  label-for="input-sm">
      <b-form-textarea id="Cadena_Original" size="sm"
                    v-bind:value="datos.cadenaOriginal"
                    readonly
                    rows="3"
                    max-rows="6">
      </b-form-textarea>
    </b-form-group>

  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"

export default {
  computed: {
    ...mapGetters({
      datos: "datosQR/datos",
    }),
  },
  mounted() {
    this.callEndpoint()
  },
  methods: {
    ...mapActions({
      getDatosQR: "datosQR/getDatosQR"
    }),

    callEndpoint() {
      this.getDatosQR(this.$route.query.id_folio)
        .then()
        .catch(error => {
          console.error(error)
        })
    },
  },
}
</script>